import { Link } from "office-ui-fabric-react"

const GlobalSettingsTooltip = () => {
    return <div>
        Define your Tenant timezone. Update tasks' and key dates' statuses imported from external systems will occur daily at Midnight according to the selected timezone.
        <br />
        Please refer to the <Link href="https://help.ppm.express/89495-ppm-express-settings/522610" target="_blank">article</Link> for more details.
    </div>
}

export default GlobalSettingsTooltip;